Ext.define('SA.view.plugin.GridColumnDragReorder', {
    alias: 'plugin.sa-grid-column-drag-reorder',
    extend: 'SA.view.plugin.DragReorder',
    pluginId: 'sa-grid-column-drag-reorder',

    direction: 'horizontal',
    itemDragCls: 'sa-report-grid-column-drag',
    itemSelector: '.sa-grid-column',
    resetEvent: 'update:cells',

    afterDrag() {
        var grid = this.cmp;

        grid.columns.forEach(column => {
            column.cellCls = (column.cellCls || '').replace(/ *sa-report-grid-cell-drag/g, '');
        });

        grid.updateCells();
    },

    beforeDrag(itemEl) {
        var grid = this.cmp,
            column = grid.findByEl(grid.columns, itemEl);

        if (column.locked) {
            return false;
        }

        this.dragColumn = column;

        column.cellCls = (column.cellCls || '') + ' sa-report-grid-cell-drag';

        if (column.forceRender) {
            grid.updateCells();
        }
        else {
            column.forceRender = true;

            grid.setColumns(grid.columns);
        }
    },

    getParentEl() {
        return this.cmp.normalHeader.dom;
    },

    getScrollEl() {
        return this.cmp.normalWrap.dom;
    },

    resetStyles() {
        var parentEl = this.getParentEl(),
            els = Ext.fly(parentEl).query(this.itemSelector),
            scrollEl = this.getScrollEl();

        Ext.Array.push(els, Ext.fly(scrollEl).query('.sa-grid-cell'));

        els.forEach(el => {
            Ext.fly(el).setStyle({
                transform: null,
                transition: null
            });
        });
    },

    translateItemImpl(item, transform, transition) {
        var grid = this.cmp,
            column = grid.findByEl(grid.columns, item),
            rows = grid.rows;

        Ext.fly(item).setStyle({transform, transition});

        rows.forEach(row => {
            row.cells.forEach(cell => {
                if (cell.column === column) {
                    Ext.fly(cell.el).setStyle({transform, transition});
                }
            });
        });
    }
});